export const TITLE = '';
export const rejectReasons = [
  'Incomplete application / missing or false information',
  'Poor Credit History - does not meet threshold',
  'Inadequate Income',
  'Tenant does not agree to lease terms',
  'Criminal history / adverse rental history'
];
